<template>
    <div class="product-logo" :class="{animate}">
        <div class="product-logo__logo slide-in">
            <MaltImg src="/cms-front/maltLogo.png?vh=1a0fcb" alt="Malt logo" width="215" />
        </div>
        <div class="product-logo__label slide-in" style="transform: translate3d(15%, 0, 0)">
            <p>Keynote.</p>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {MaltImg} from '#components';

    defineProps<{animate?: boolean}>();
</script>

<style lang="scss">
    .product-logo {
        text-align: left;
        img {
            width: 50%;
            line-height: 0;
            display: block;

            path {
                fill: currentColor;
            }
        }

        &__label {
            width: 100%;
            line-height: var(--joy-line-height-small);
            font-family: var(--joy-font-family-title);
            font-weight: var(--joy-font-weight-bold);
            transform: translate3d(0, 100%, 0);
            transform: translate3d(15%, 0, 0);
        }
    }
</style>
